import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackLink = ({ to, label }) => (
  <Link to={to} data-testid="detail-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-zinc-300 hover:text-primary transition-colors">
    <ArrowLeft className="w-4 h-4" /> {label}
  </Link>
);

export const NotFound = ({ to, label }) => (
  <section className="pt-48 pb-32 max-w-[1600px] mx-auto px-5 md:px-10" data-testid="detail-not-found">
    <p className="font-display uppercase text-5xl md:text-7xl text-white">Introuvable<span className="text-primary">.</span></p>
    <p className="text-zinc-400 mt-4 mb-8">Cette page n'existe pas ou a été retirée.</p>
    <BackLink to={to} label={label} />
  </section>
);

export const DetailSkeleton = () => (
  <section className="pt-40 pb-32 max-w-[1600px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12">
    <div className="aspect-square bg-[hsl(var(--surface))] animate-pulse" />
    <div className="space-y-4">
      <div className="h-16 bg-[hsl(var(--surface))] animate-pulse" />
      <div className="h-40 bg-[hsl(var(--surface))] animate-pulse" />
    </div>
  </section>
);
